import { memo } from 'react';

import {
  PrivateGalleryFile,
  type PrivateGalleryFileProps,
} from '~/components/v2/components/board/gallery/PrivateGalleryFile';

export type PrivateBoardGalleryViewFileProps = Omit<PrivateGalleryFileProps, 'trackLocation' | 'ancestors'>;

export const PrivateBoardGalleryViewFile = memo(({ box, data, index }: PrivateBoardGalleryViewFileProps) => {
  return <PrivateGalleryFile box={box} data={data} index={index} />;
});

PrivateBoardGalleryViewFile.displayName = 'PrivateBoardGalleryViewFile';
